<!-- <div class="tcCon">
    <div class="tjcoSize">确定要改变时间吗，未保存的数据可能会丢失</div>
    <div class="qxtjBtn">
        <button (click)="cancel()">取消</button>
        <button (click)="confirm()">确定</button>
    </div>
</div> -->


<div class="modal-primary" role="document">
    <div class="modal-content">
        <div class="modal-header borderBottom">
            <h4 class="modal-title sizef08200-title">系统提示</h4>
            <button type="button" class="close" (click)="cancel()" aria-label="Close" style="padding: 0; margin: 0;">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        
        <h4 class="pT20 dFlex thimg">
            <img src="assets/yxzx_ic_tx.png" alt="">
            您要切换日期，是否保存数据？
        </h4>
        <div class="modal-footer">
            <div>
                <button (click)="cancel()">取消</button>
            </div>
            <div class="qdBtn">
                <button (click)="confirm()">确认</button>
            </div>

            <!-- <div><button type="button" class="btn btn-outline-primary" (click)="cancel()">1{{cancelButtonName}}</button></div>
            <div *ngIf="confirmButtonShowFlag"><button   type="button" class="btn btn-outline-primary" (click)="confirm()">确定</button></div> -->
        </div>
        

    </div>
</div>

